// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { intersperse } from 'ramda';

// local
import styles from './CityLove.pcss';


export default class CityLove extends PureComponent {

  static propTypes = {
    cities: PropTypes.arrayOf(PropTypes.string),
    className: PropTypes.string,
  }
  
  static defaultProps = {
    cities: [],
  }
  
  heart = (<span key={ 'heart' } className={ styles.heart }>{ '♥' }</span>)

  render() {
    const { cities, className } = this.props;
    const classes = classnames(className, styles.cityLove);
    
    let text = intersperse(this.heart, cities);
    if (text.length === 1) text = [this.heart, ...text];

    return (
      <p className={ classes }>
        { text }
      </p>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/CityLove/index.jsx